/**
 * Created by Ning Jiang on 2021-06-28.
 */

import {WinPresentationController} from "../WinPresentationController";
import {TimelineLite} from "gsap";
import {DeadwoodRip} from "../../DeadwoodRip";
import {DeadwoodRipSymbolState} from "../../symbol/DeadwoodRipSymbolConfig";
import {DeadwoodRipReelSplitSymbol} from "../../symbol/DeadwoodRipReelSplitSymbol";
import {DeadwoodRipS1Symbol} from "../../symbol/DeadwoodRipS1Symbol";
import {DeadwoodRipBackground} from "../../view/DeadwoodRipBackground";
import {DeadwoodRipSound} from "../../sound/DeadwoodRipSound";

export class S1ToWRSTransformController extends WinPresentationController {

    constructor() {
        super("S1ToWRSTransformController", false);
    }

    protected hasWin():boolean {
        return DeadwoodRip.model.parsedGameData.transformScatterToReelSplit.some(p => p > -1);
    }

    protected async createWinAnimation():Promise<any> {
        DeadwoodRip.playScattersWin = true;
        const tl = new TimelineLite();
        let isFirst = true;
        DeadwoodRip.model.parsedGameData.transformScatterToReelSplit.forEach((symId, reelId) => {
            if(symId > -1) {
                const reel = DeadwoodRip.reels[reelId];
                const newSym = new DeadwoodRipReelSplitSymbol(reelId, DeadwoodRipSymbolState.NORMAL);
                // newSym.showScatterFrame();
                const oldSym = <DeadwoodRipS1Symbol>reel.getSymbol(symId);
                newSym.position.set(oldSym.x, oldSym.y);
                newSym.visible = false;
                reel.reelView.addSymbol(newSym);
                // reel.reelView.addSymbol(oldSym);
                reel.reelView.allSymbols[reel.reelView.allSymbols.indexOf(oldSym)] = newSym;

                const symTl = new TimelineLite();
                if(isFirst) {
                    symTl.add(() => {
                        DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.S1_WIN});
                    });
                }
                symTl.add(oldSym.playTransferWRS());
                if(isFirst) {
                    symTl.add(() => {
                        DeadwoodRipBackground.shakeStageOnce(0.4);
                        DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.SCATTER_TO_WILD});
                    });
                }
                isFirst = false;
                symTl.add([
                    () => {
                        reel.reelView.removeSymbol(oldSym);
                        oldSym.onRemove();
                        newSym.visible = true;
                    },
                    newSym.playLanding()
                ]);
                tl.add(symTl, 0);
            }
        });

        await Promise.resolve(tl);
    }
}